import React, { useState, useRef, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { Flex, Box } from 'pcln-design-system'
import { addHours, compareAsc } from 'date-fns'

import SelectTime from '../SelectTime'
import { topOfHour } from './helpers'

export default function TimeRange({ min, max, onChange, defaultStart, defaultEnd, name }) {
  const [start, setStart] = useState(defaultStart)
  const [end, setEnd] = useState(topOfHour(defaultEnd))

  const firstUpdate = useRef(true)
  useLayoutEffect(() => {
    // Don't run change handler on mount
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }

    // Update end time
    const updatedEnd = compareAsc(start, end) >= 0 ? addHours(start, 1).getTime() : end

    onChange([start, updatedEnd])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start, end])

  function _onStartChange(val) {
    setStart(val)
  }

  function _onEndChange(val) {
    setEnd(val)
  }

  return (
    <Flex align={'center'} alignItems={'center'} w={1} width={1}>
      <SelectTime min={min} max={max} name={`${name}_start`} onChange={_onStartChange} value={start} />
      <Box p={1}>&ndash;</Box>
      <SelectTime
        min={addHours(start, 1).getTime()}
        max={max}
        name={`${name}_end`}
        onChange={_onEndChange}
        value={end}
        isEndTime
      />
    </Flex>
  )
}

TimeRange.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  defaultStart: PropTypes.number,
  defaultEnd: PropTypes.number,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
}
